import { render } from "./Text.vue?vue&type=template&id=9b448850&scoped=true"
import script from "./Text.vue?vue&type=script&lang=ts"
export * from "./Text.vue?vue&type=script&lang=ts"

import "./Text.vue?vue&type=style&index=0&id=9b448850&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-9b448850"

export default script